// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"8ce9da75","167":"0b4e4cfe","397":"163ff91f","450":"b72d5a5b","453":"506b1de4","488":"7c32629f","921":"c45dbe2c"}[chunkId] + ".chunk.js";
};